import { atom } from "recoil";

export const preloaderState = atom({
    key: 'preloader',
    default: false
});
